// extracted by mini-css-extract-plugin
export default {"container":"Collection_container__RKB7w"};